module.exports = __webpack_public_path__ + "img/hr-dead-dry-hairy-tree-03.83e2d916.png";